var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '../../../../../infra/i18n';
import { platformsConfig } from '../platforms-config';
import { Button } from '../../../../../infra/ui/button';
export var ImportForm = function (_a) {
    var selectedPlatform = _a.selectedPlatform, importForm = _a.importForm, onSubmitImportForm = _a.onSubmitImportForm;
    return (_jsxs("form", { onSubmit: importForm.handleSubmit(onSubmitImportForm), children: [_jsx("div", { className: "u-mt", children: t('common:import.title') }), _jsx("div", { className: "c-label-new u-mt-", children: platformsConfig[selectedPlatform].authenticationItemName && t('common:import.token_label') }), _jsx("div", { children: _jsx("input", __assign({ className: "c-input u-width-100" }, importForm.register('token', { required: true }), { disabled: importForm.formState.isSubmitting })) }), _jsx(Button, { type: "submit", className: "u-mt-", disabled: !importForm.formState.isValid || importForm.formState.isSubmitting, children: t('common:import.start_button') })] }));
};
